import { ProcessType } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonProjectProcessOverview } from "../../CommonComponents/CommonProjectProcessViews";
export const ProjectRunbookProcessStepTemplatesRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.project().runbook.process.stepTemplates,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonProjectProcessOverview processType={ProcessType.Runbook}/>;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
